<template>
  <div>
    <div v-if="visible" class="overlay">
      <div class="cube">
        <div class="cube_item cube_x"></div>
        <div class="cube_item cube_y"></div>
        <div class="cube_item cube_y"></div>
        <div class="cube_item cube_x"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LoadOverlay',

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

}
</script>
<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.cube {
  height: 80px;
  width: 80px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
}

.cube_item {
  height: 40px;
  width: 40px;
  border-radius: 10px;
  transition: all 0.2s ease-in;
}

.cube_x {
  background-color: blueviolet;
  animation: animateLoaders 1s infinite;
}

.cube_y {
  background-color: aqua;
  animation: animateLoaders 1s 0.5s infinite;
}

@keyframes animateLoaders {
  0% {
    transform: scale(0.8);
  }

  50% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(0.8);
  }
}
</style>